// extracted by mini-css-extract-plugin
export default {"navbarTitle":"nav-bar_navbarTitle__FaDSZ"};